/* eslint-disable */
import { Box, Step, StepLabel, Stepper, Typography } from "@mui/material";

function StepProgress({ activeStep, formState }) {
  const steps = ["Target Keyword", "Page Title", "Intro Paragraph", "Headings"];

  const limitWords = (text, limit = 20) => {
    if (!text) return "";
    // const words = text;
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };

  const handleSwitchCase = index => {
    switch (index) {
      case 0:
        return formState?.keyword || "";
      case 1:
        return limitWords(formState?.selectedTitle || "");
      case 2:
        return limitWords(formState?.selectedParagraph || "");
      case 3:
        return limitWords(formState?.selectedHeading || "");
      default:
        return "";
    }
  };

  return (
    <Box className="stepperBox">
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>
              <Typography component="p">
                {label}: <Typography component="span">{handleSwitchCase(index)}</Typography>
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

export default StepProgress;
